import styled from 'styled-components';

import { colors } from '../../constants/styleConstants';

const Button = styled.button`
  background: ${colors.principalOrange};
  border: none;
  border-radius: .2rem;
  color: ${colors.white};
  font-size: ${props => props.fontSize};
  padding: ${props => props.padding};
  margin: ${props => props.margin};
  text-align: center;
  width: ${props => props.width};;

  &:hover,
  &:focus {
    background-color: ${colors.reddishOrange};
  }
`;

Button.defaultProps = {
  fontSize: '1.8em',
  padding: '0',
  margin: '0',
  width: 'auto'
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/common/Button.js